import React, { PropsWithChildren, useMemo } from 'react';
import { AccountInfoType, UserType } from 'shared/types';
import {
  AccessControl,
  AccessControlParams,
  ROLE_ACCESS,
  RoleType,
} from './utils/access-control';

export const AccessProvider: React.FC<PropsWithChildren<any>> = ({
  children,
}) => {
  const [role, setRole] = React.useState<RoleType>('VIEWER');
  const [user, setUser] = React.useState<UserType>();
  const [account, setAccount] = React.useState<AccountInfoType>();

  const updateRole = (type: any) => {
    setRole(type);
  };

  const updateAccount = (data?: AccountInfoType) => {
    if (data?.id) setAccount(data);
  };
  const updateUser = (data?: UserType) => {
    if (data?.display_id) setUser(data);
  };

  const initialValue = useMemo<AccessControlParams>(
    () => ({
      role,
      access: ROLE_ACCESS[role],
      updateRole,
      user,
      account,
      updateAccount,
      updateUser,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [role],
  );

  return (
    <AccessControl.Provider value={initialValue}>
      {children}
    </AccessControl.Provider>
  );
};

export default AccessProvider;
